import { Component, Fragment } from "react";
import { compose } from "redux";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";

import TableNew, { CELL_TYPES } from "../../../shared/Table";
import RefreshButton from "../../../shared/ui/Refresh.Button";
import CurrencyFormater from "../../../shared/ui/Currency.Input";

import { moneyFormater } from "../../../utilities/formaters";

import { specialAccountsConnector } from "../../../services/specialAccounts/connector";

class SpecialAccountsComponent extends Component {
  constructor(props) {
    super(props);

    let columns = [
      { key: "Id", label: "Id", visible: true, type: CELL_TYPES.text },
      {
        key: "SpecialAccount",
        label: "Account",
        visible: true,
        type: CELL_TYPES.text,
      },
      {
        key: "Amount",
        label: "Amount",
        visible: true,
        type: CELL_TYPES.number,
      },
      {
        key: "Currency",
        label: "Currency",
        visible: true,
        type: CELL_TYPES.text,
      },
      {
        key: "Type",
        label: "Withdraw/Deposit",
        visible: true,
        type: CELL_TYPES.text,
      },
      { key: "Notes", label: "Notes", visible: true, type: CELL_TYPES.text },
      {
        key: "Executed",
        label: "Executed",
        visible: true,
        type: CELL_TYPES.number,
      },
      {
        key: "actions",
        label: "Actions",
        visible: true,
        renderer: (value, item) => {
          return (
            <Fragment>
              <Button
                variant="contained"
                color="primary"
                onClick={this.confirmTransactionOrder.bind(this, item.Id)}
                disabled={item.Executed}
              >
                {item.Executed ? "Confirmed" : "Confirm"}
              </Button>
              {!item.Executed && (
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={this.cancelTransactionOrder.bind(this, item.Id)}
                >
                  Cancel
                </Button>
              )}
            </Fragment>
          );
        },
      },
    ];

    this.state = {
      Amount: "",
      Notes: "",
      Columns: columns,
    };
  }

  UNSAFE_componentWillMount() {
    this.props.loanstepSpecialAccountsBalances();
    this.props.loanstepGetTransactionOrders();
  }

  changeAccount = (event) => {
    this.setState({ AccountId: event.target.value });
  };

  refresh() {
    this.props.loanstepSpecialAccountsBalances();
    this.props.loanstepGetTransactionOrders();
  }

  handleChangeAmount = (event) => this.setState({ Amount: event.target.value });

  handleChangeNotes = (event) => this.setState({ Notes: event.target.value });

  withdraw = () => {
    this.props.loanstepWithdraw(
      this.state.Amount.replace(",", ".").replace(" ", ""),
      this.state.AccountId,
      this.state.Notes,
    );
    this.setState({ Amount: "", Notes: "" });
    setTimeout(() => {
      this.refresh();
    }, 500);
  };

  deposit = () => {
    this.props.loanstepDeposit(
      this.state.Amount.replace(",", ".").replace(" ", ""),
      this.state.AccountId,
      this.state.Notes,
    );
    this.setState({ Amount: "", Notes: "" });
    setTimeout(() => {
      this.refresh();
    }, 500);
  };

  getTransactionOrders = () => {
    this.props.loanstepGetTransactionOrders();
  };

  confirmTransactionOrder = (id) => {
    this.props.loanstepConfirm(id);
    setTimeout(() => {
      this.refresh();
    }, 500);
  };
  cancelTransactionOrder = (id) => {
    this.props.loanstepCancel(id);
    setTimeout(() => {
      this.refresh();
    }, 500);
  };

  render = () => {
    let wrapperStyle = {
      display: "flex",
      justifyContent: "center",
      flexWrap: "wrap",
    };
    let halfItemStyle = {
      minWidth: "450px",
      width: "50%",
      height: "100%",
      padding: "10px",
      boxSizing: "border-box",
    };

    return (
      <div>
        <div className="accounting-layout body-height" style={wrapperStyle}>
          <div style={halfItemStyle}>
            <Card>
              <CardHeader title="Account balances" />
              <CardContent>
                {this.props.balances.map((balance, index) => {
                  return (
                    <div key={`balances-${index}`}>
                      <strong>{balance.Name}:</strong>{" "}
                      {moneyFormater(balance.Balance.Amount)}
                      <br />
                    </div>
                  );
                })}
              </CardContent>
            </Card>
          </div>
          <div style={halfItemStyle}>
            <Card>
              <CardHeader title="Register deposit / withdrawal" />
              <CardContent>
                <div>
                  <div>
                    <TextField
                      size="small"
                      variant="outlined"
                      label="Account Id"
                      select
                      value={this.state.AccountId}
                      onChange={this.changeAccount}
                    >
                      {this.props.balances.map((balance, index) => {
                        return (
                          <MenuItem
                            key={"Account-Item-" + index}
                            value={balance.Id}
                          >
                            {balance.Name}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </div>
                  <div>
                    <CurrencyFormater
                      id="Amount-field"
                      label="Amount"
                      value={this.state.Amount}
                      onChange={this.handleChangeAmount}
                      fullWidth={false}
                    />
                  </div>
                  <div>
                    <TextField
                      size="small"
                      variant="outlined"
                      id="Notes-field"
                      label="Notes"
                      value={this.state.Notes}
                      onChange={this.handleChangeNotes}
                    />
                  </div>
                </div>
              </CardContent>
              <CardActions>
                <Button
                  variant="contained"
                  color="primary"
                  primary={true}
                  onClick={this.withdraw}
                >
                  Withdraw
                </Button>

                <Button
                  variant="contained"
                  color="primary"
                  primary={true}
                  onClick={this.deposit}
                >
                  Deposit
                </Button>
              </CardActions>
            </Card>
          </div>
        </div>
        <div className="col-md-12">
          <RefreshButton onRefreshClick={this.getTransactionOrders} />
          <TableNew
            {...this.props}
            columns={this.state.Columns}
            items={this.props.transactionOrders}
            tableKey={"loanstepTransactionOrders"}
            actionColumnWidth={240}
          />
        </div>
      </div>
    );
  };
}
export default compose(specialAccountsConnector)(SpecialAccountsComponent);
